import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Injectable()
export class AwsTokenInterceptor implements HttpInterceptor {
    constructor(private injector: Injector, private apiservice: ApiService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.startsWith('/')) {
            if (!req.headers.has('x-api-key')) {
                const dupReq = req.clone({
                    setHeaders: {
                        'x-api-key': this.apiservice.getAwsGatewayToken(),
                    },
                });

                return next.handle(dupReq);
            }
        }

        return next.handle(req);
    }
}
